<template>
        <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
            <!-- Alert Messages -->
            <div>
                <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
            </div>
            <div>

                <div v-if="headerText === 'Liquidation'">
                    <div v-if="bcl_action == 'pending_dispatch_file_upload'">
                        <HeaderComponent :headerTitle="headerText" :router-link="getRouterLink()" :router-link-text="getRouterLinkText()" :return-condition="true" :component-name="componentsName()" />
                    </div>
                    <div v-else>
                        <HeaderComponent :headerTitle="headerText" :createLotComtBidding="createLotComtBidding" :lotIdB2b="lotIdB2b" :action="action"/>
                    </div>
                </div>
                <!-- <div v-if="$store.state.config.allowedHeaders.includes(this.headerText)">
                    <HeaderComponent :headerTitle="headerText" :router-link="getRouterLink()" :router-link-text="getRouterLinkText()" :return-condition="true" :component-name="componentsName()" />
                </div> -->
                <div v-if="showHeader">
                    <HeaderComponent :headerTitle="(headerText === 'Insurance' || headerText === 'Brand Call Log' || headerText === 'RTV') ? headerText : headerTextSub" 
                     :router-link="getRouterLink()" :router-link-text="getRouterLinkText()" :return-condition="true" :component-name="componentsName()" />
                </div>
            </div>
            <!-- search, Action buttons -->
            <v-card class="v-card-100 mt-0" v-if="!bcl_action.hide_exist_action">
                <v-card-title style="padding-top: 10px;" class=" action-style d-flex">
                    <v-text-field prepend-inner-icon="mdi-magnify" v-no-edge-space v-model="search_tag" :label="headerTextSub === 'Item Master' ? 'Search Document' : 'Search'"
                        style="max-width: 300px; margin-top: 12px;" variant="outlined" v-on:keyup.enter="loadData('search')"></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn color="primary text-none" v-if="headerTextSub !== 'Physical Inspection'" size="x-large" class="mt-3" @click="uploadDocum">Upload</v-btn>
                </v-card-title>
            </v-card>
            <v-card class="v-card-100 mt-0" v-else>
                <v-card-title style="padding-top: 10px;" class="action-style d-flex pa-6">
                    <div class="card-label-style">{{bcl_action.approval_type}}: <span class="font-weight-bold">{{headerTextSub}}</span></div> 
                    <span class="ml-2 mt-2"> <v-icon color="primary" :class="{ 'rotate-once': isRotating }" @click="loadData">mdi-reload</v-icon> </span>
                </v-card-title>
                
            </v-card>
            <v-layout column>
                <v-col cols="12" class="px-0" style="overflow: auto">
                    <v-data-table hover density="compact" :headers="headers" :items="table_data" disable-pagination
                       :hide-default-footer="true" :loading="loading" loading-text="Loading Data... Please wait"
                       fixed-header
                       height="100%"
                        class="elevation-1" :items-per-page="pageSize">
                        <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
                            <span v-if="header.key == 'inventory_file'">
                                <p>{{getFileName(item.inventory_file.url)}}</p>
                            </span> 
                            <span v-else-if="header.key == 'master_file'">
                                <p>{{headerTextSub === 'Physical Inspection' ? item.filename : getFileName(item.master_file.url)}}</p>
                            </span> 
                            <span v-else-if="header.key == 'org_file'">
                                <div>
                                 <v-btn variant="outlined" class="cancel-color my-1 text-none" color="primary" @click="downloadDocum(item)">Download</v-btn>
                                </div>                            
                            </span> 
                            <span v-else-if="header.key == 'status'">
                                <span v-if="item.status == 'Completed'">{{ item.status }}
                                    <v-icon color="success" size="18">mdi-alert-circle</v-icon>
                                </span>
                                <span v-else-if="item.status == 'Halted'">{{ item.status }}
                                    <v-icon color="warning" size="18">mdi-alert-circle</v-icon>
                                </span>
                                <span v-else-if="item.status == 'Failed' || item.status == 'Fail'">{{ item.status }}
                                    <v-icon color="error" size="18">mdi-alert-circle</v-icon>
                                </span>
                                <span v-else-if="!item.status">Pending</span>
                                <span v-else>{{ item.status }}</span>
                            </span> 
                            <span v-else-if="header.key == 'remarks'">
                                <div v-if="headerTextSub === 'User Master' || 
                                           headerTextSub === 'Vendor Master' || 
                                           headerTextSub === 'Item Master' || 
                                           headerTextSub === 'Location Master' || 
                                           headerTextSub === 'Approval Matrix' || 
                                           headerTextSub === 'Replacement' || 
                                           headerTextSub === 'Restock' || 
                                           headerTextSub === 'Markdown' ||
                                           headerTextSub === 'Generate & Track Tag IDs' ||
                                           headerTextSub === 'Repair' || 
                                           headerTextSub === 'Dispatch' ||
                                           headerTextSub === 'Transfer' ||
                                           headerText === 'RTV' ||
                                           headerText === 'AI Pricing File Upload' ||
                                           headerTextSub === 'Manage Buyers' || 
                                           headerTextSub === 'BB CRM Surrogate' ||
                                           headerTextSub === 'Physical Inspection' || this.headerTextSub === 'Request & Tickets' || this.headerTextSub === 'Return Creation'">
                                   <span v-if="item.status !== 'Completed' && item.status !== 'Import Started' && item.status !== null && item.status !== 'Pending' && item.status !== 'pending' && item.status !== 'Uploading' && item.status !== 'Success'"><a style="text-decoration:underline; color:#007BFF; cursor: pointer;" @click="showError(item)">View Error</a></span>
                                </div>
                                <div v-else>
                                    <span v-if="item.remarks"><a style="text-decoration:underline; color:#007BFF; cursor: pointer;"
                                            @click="showError(item)" return-object>View Error</a></span>
                                    <span v-else>-</span>
                                </div>                           
                             </span>
                             <span v-else-if="header.key !== '' && item[header.key]">
                                <span v-tooltip="item[header.key]">
                                {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                                </span>
                            </span>
                            <span v-else>-</span>
                        </template>
                        <template #bottom></template>
                    </v-data-table>
                </v-col>
            </v-layout>
            <div>
                <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-1 mb-1"
                />
            </div>
                    <!-- File Upload popup -->
        <v-row justify="center">
            <v-dialog v-model="fileUploadPopup" persistent max-width="424px">
                <v-card class="v-card-100">
                    <v-card-title class="d-flex align-center">
                    <v-row class="ma-1">
                        <span v-if="headerTextSub === 'Item Master'">Upload {{this.headerText}}</span>       
                        <span v-else>Upload Csv File</span>
                        <v-spacer></v-spacer>
                        <!-- <v-btn @click="cancelUploadFile"> -->
                            <v-icon @click="cancelUploadFile">mdi-close</v-icon>
                        <!-- </v-btn> -->
                    </v-row>
                    </v-card-title>
                    <v-divider :thickness="4" class="m-0" />
                    <v-card-text>
                        <!-- <span class="sample-file" v-if="headerText === 'Liquidation'">                            
                            <a class="sample-color mr-2" style="cursor: pointer;"  href="https://beam-saas-dev.s3.ap-south-1.amazonaws.com/uploads/inventory_file_upload/inventory_file/2880/Sample_lot_file.csv">Download Sample File</a>
                        </span> -->
                        <span class="sample-file" v-if="headerText === 'Dealer/Partner Return Approval'">                            
                            <a class="sample-color mr-2" style="cursor: pointer;" @click="downloadSampleFile">Download Sample File</a>
                        </span>
                        <span class="sample-file" 
                              v-else-if="headerTextSub === 'User Master' ||  
                                         headerTextSub === 'Item Master' || 
                                         headerTextSub === 'Vendor Master' || 
                                         headerTextSub === 'Location Master' || 
                                         headerTextSub === 'Approval Matrix' || 
                                         headerTextSub === 'AI Pricing File Upload' || 
                                         headerTextSub === 'BB CRM Surrogate' ||
                                         headerText === 'Brand Call Log' ||
                                         headerText === 'Insurance' ||
                                         headerTextSub === 'Replacement' ||
                                         headerTextSub === 'Dispatch' ||
                                         headerTextSub === 'Markdown' ||
                                         headerTextSub === 'Generate & Track Tag IDs' ||
                                         headerText === 'RTV' ||
                                         bcl_action === 'create_lot' ||
                                         headerTextSub === 'Manage Buyers' ||
                                         bcl_action == 'pending_dispatch_file_upload' ||
                                         headerText === 'Define Channel' || headerText === 'Return Reason Master' || headerTextSub === 'Return Types Master' || headerTextSub === 'Entity-Variable Masters' || headerText === 'Attribute Configuartion' ||
                                         headerText === 'Liquidation Price' || headerTextSub === 'Notification Types' || headerTextSub === 'Approval Type' || headerTextSub === 'Rule Type' || headerTextSub === 'Grading Type' || headerTextSub === 'Notification Template' || headerText === 'Depreciation Master' || headerTextSub === 'Front End Title Master' || headerText === 'Field Nomenclature Mapping'">                            
                            <a class="sample-color mr-2" style="cursor: pointer;"  @click="downloadSampleFileUserMaster">Download Sample File</a>
                        </span>
                        <v-container class="pa-0 pr-3">
                            <v-file-input
                                v-model="upload_file"
                                :label="label_name"
                                @update:modelValue="changeFile"
                                style="margin-top: 16px;"
                                :accept="fileAccept"
                                :error="fileError"
                                :error-messages="fileErrorMessage"
                                variant="outlined"
                                class="overflow-hidden pt-3"
                            >
                            </v-file-input>
                            <div v-if="uploading">
                                Uploading file ({{ uploadPercentage }}%)
                                <v-progress-linear
                                :model-value="uploadPercentage"
                                color="blue"
                                height="10"
                                ></v-progress-linear>
                            </div>
                            <div v-if="completed">
                                <v-progress-linear
                                :value="uploadPercentage"
                                color="blue"
                                height="10"
                                ></v-progress-linear>
                                <p style="color:green;text-align: right;">Completed</p>
                            </div>
                        </v-container>
                    </v-card-text>
                    <v-card-actions center>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" variant="flat" class="mb-3 text-none" v-if="this.confirmButton != 'FINISH'" @click="confirmUploadFile" :disabled="!upload_file || number>0 || fileError">Confirm</v-btn>
                        <v-btn color="primary" variant="flat" class="mb-3 text-none" v-if="this.confirmButton == 'FINISH'" @click="clickFinish" :disabled="!upload_file || number>0">Finish</v-btn>
                        <v-btn variant="outlined" color="primary" class="cancel-color mb-3 text-none" v-if="cancel_button_hide === false" :disabled="number > 0" @click="cancelUploadFile">Cancel</v-btn>   
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
         <!-- message popup -->
         <v-row justify="center">
            <v-dialog v-model="messagePopup" persistent :max-width="messagePopWidth">
                <v-card class="v-card-100">
                    <v-card-title class="d-flex align-center pa-2 pt-0">
                        <span></span>
                        <v-spacer></v-spacer>
                        <v-btn icon variant="text" @click="messagePopup = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span>{{ message }}</span>
                    </v-card-text>
                    <v-card-actions class="pb-4">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" class="text-none" variant="flat" @click="loadData" v-if="action_name == 'success_msg'">Ok</v-btn>
                        <v-btn color="primary" class="text-none" variant="flat" @click="downloadError" v-if="action_name == 'download_error'">Download</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-card>
</template>
<script>
import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue';
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
export default {
    data() {
        return {
            headerText: "",
            selected: [],
            file: '',
            binaryData: '',
            alert_type: 'info',
            alert_message: '',
            alert: false,
            menu: false,
            loading: false,
            search_tag: '',
            headers: [],
            table_data: [],
            page : 1,
            pageSize: defaultPageSize,
            pageSizes: defaultPageSizes,
            totalPages : 1,
            totalCount: '',
            fileUploadPopup : false,
            upload_file : null,
            uploading: false,
            completed: false,
            confirmButton:'CONFIRM',
            number: 0,
            uploadPercentage: 0,
            messagePopup : false,
            messagePopWidth:'',
            createLotComtBidding:true,
            action:'',
            lotIdB2b:'',
            message:'',
            action_name:'',
            bcl_condition:'',
            bcl_action:'',
            status_name:'',
            headerTextSub:'',
            fileAccept: '.csv',
            label_name:'Attach Csv file',
            cancel_button_hide: false,
            fileErrorMessage:'',
            fileError: false,
            search_key :'',
            master_url:'',
            isRotating: false,
        }
    },
    components: {
        HeaderComponent
    },
    computed: {
        showHeader() {
            console.log(this.$store.state.config.allowedHeaders)
            return (this.$store.state.config.allowedHeaders.includes(this.headerTextSub) || this.$store.state.config.allowedHeaders.includes(this.headerText))
        }
    },
    async created(){
        this.bcl_condition = this.$store.state.lotIds;
        this.headerTextSub = this.$store.state.lotIds;
        this.bcl_action = this.$store.state.action;
        this.headerText = this.$store.state.inventoryId; 
        this.action = 'file_upload'     
        if(this.action === 'file_upload'){
          this.ids = this.$store.state.lotIds;
        }
        if (this.bcl_condition === 'brand_call_log') {
            if(this.bcl_action === 'Pending Information'){
                this.status_name = 'pending_information'
            }else if(this.bcl_action === 'Pending BCL Tickets'){
                this.status_name = 'pending_bcl_ticket'
            }else if(this.bcl_action === 'Pending Inspection'){
                this.status_name = 'pending_inspection'
            }else{
                this.status_name = 'pending_decision'
            }
        } else if(this.bcl_condition === 'insurance_operations') {
            if(this.bcl_action === 'Pending Information'){
                this.status_name = 'pending_information'
            }else if(this.bcl_action === 'Pending Claim Ticket'){
                this.status_name = 'pending_claim_ticket'
            }else if(this.bcl_action === 'Pending Inspection'){
                this.status_name = 'pending_inspection'
            }else{
                this.status_name = 'pending_decision'
                }
        } else if(this.bcl_condition === 'rtv'){
            this.status_name = 'Pending Confirmation'
        }
        this.loadData();
        this.updateAccept();
    },
    methods: {
         updateAccept() {
                if (this.headerText === 'Master Location' || 
                    this.headerText === 'Forward Location Mapping' || 
                    this.headerText === 'Reverse Location Mapping') {
                    this.fileAccept = '.csv,.xls';
                    this.label_name = 'Attach Csv or Xls file'
                } else {
                    this.fileAccept = '.csv';
                    this.label_name = 'Attach Csv file'
                }
            },
        showAlert(alert_type, alert_message) {
            this.alert = true;
            this.alert_type = alert_type;
            this.alert_message = alert_message;
            this.alertTimeOut();
        },
        alertTimeOut() {
            setTimeout(() => {
                this.alert = false;
            }, 3000);
        },
        loadData(value){
            this.isRotating = true
            this.search_key = value
            this.loading = true;
            this.messagePopup = false;           
            if (this.headerText === 'Dealer/Partner Return Approval' || this.headerTextSub === '3P Claim' || this.headerTextSub === 'Return Creation') {
                this.headers = [
                    { title: "ID", key: "id" },
                    { title: "File Name", key: "filename" },
                    { title: "Status", key: "status", minWidth:"120px" },
                    { title: "Uploaded Date & Time", key: "updated_at",minWidth:"200px"  },
                    { title: "Remarks", key: "remarks" },
                    { title: "Original File", key: "org_file" }
                ];
            } else if (this.headerText === 'User Master' || 
                       this.headerTextSub === 'Item Master' || 
                       this.headerText === 'User Mapping'  || 
                       this.headerText === 'Vendor Master' || 
                       this.headerText === 'Vendor Mapping' || 
                       this.headerTextSub === 'Location Master' || 
                       this.headerTextSub === 'Approval Matrix' || 
                       this.headerText === 'Pending Confirmation' || 
                       this.headerText == 'Pending Restock Location' || 
                       this.headerText === 'Pending Price & Location' || 
                       this.headerText === 'Pending Repair' || 
                       this.headerText === 'Pending Dispatch' || 
                       this.headerTextSub === 'Transfer' || 
                       this.headerTextSub === 'AI Pricing File Upload' || 
                       this.headerTextSub === 'BB CRM Surrogate' || 
                       this.headerTextSub === 'Generate & Track Tag IDs' ||
                       this.headerTextSub === 'Manage Buyers' ||
                       this.headerText === 'Create New Approval Config' ||
                       this.headerText === 'Define Channel' ||
                       this.headerText === 'Return Reason Master' ||
                       this.headerText === 'Attribute Configuartion' ||
                       this.headerTextSub === 'Return Types Master' ||
                       this.headerTextSub === 'Entity-Variable Masters' ||
                       this.headerTextSub === 'Physical Inspection' || this.headerTextSub === 'Request & Tickets' ||
                       this.headerText === 'Liquidation Price' || this.headerTextSub === 'Notification Types' || this.headerTextSub === 'Approval Type' || this.headerTextSub === 'Rule Type' || this.headerTextSub === 'Grading Type' || this.headerTextSub === 'Notification Template' || this.headerText === 'Depreciation Master' || this.headerTextSub === 'Front End Title Master' || this.headerText === 'Field Nomenclature Mapping') {
                this.headers = [
                    { title: "ID", key: "id" },
                    { title: "Date & Time", key: "created_at", minWidth:"200px"  },
                    { title: "Uploaded By", key: "user_name" },                    
                    { title: "File", key: "master_file" },
                    { title: "Status", key: "status", minWidth:"120px" },
                    { title: "Remarks", key: "remarks" },
                    { title: "Original File", key: "org_file" },
                ];
                if(this.headerTextSub === 'Physical Inspection'){
                    this.headers = this.headers.filter(header => header.key !== 'user_name')
                }
            } else {
                this.headers = [
                    {title: "ID", key: "id"},
                    {title: "File", key: "inventory_file"},
                    {title: "Status", key: "status", minWidth:"120px" },
                    {title: "Uploaded Date & Time", key: "updated_at", minwidth:"200px"},
                    {title: "Remarks", key: "remarks"},
                    {title: "Original File", key: "org_file"}
                ] 
            }
                this.fetchCreatePRDIndexData();
        },
    fetchCreatePRDIndexData(){
        let params = {
            status: this.status_name,
            page : this.page,
            per_page : this.pageSize,
        };
        if(this.search_key === 'search'){
            params = {
            status: this.status_name,
            page : 1,
            per_page : this.pageSize,
        };
        }
        let endpoint = '';
        if(this.bcl_condition === 'brand_call_log'){
            endpoint = '/api/v1/warehouse/brand_call_logs/get_uploaded_files';
            params.search_text = this.search_tag;
        } else if (this.bcl_condition === 'insurance_operations') {
            endpoint = '/api/v1/warehouse/new_insurances/get_uploaded_files';
            params.search_text = this.search_tag;
        } else if (this.headerText === 'Dealer/Partner Return Approval') {
            endpoint = `/api/v1/warehouse/prd/file_uploads`;
            params.file_type = 'Dealer Partner Return Upload';
            params.search = this.search_tag;
        }else if (this.headerText === 'Inward Tracking') {
            endpoint = `/api/v1/warehouse/inward_tracking/get_uploaded_files`;
            params.search_text = this.search_tag;
        }else if(this.headerText === 'RTV'){
            endpoint = '/api/v2/warehouse/inventory_file_uploads';
            params.search_text = this.search_tag;
            params.status = "Rtv File Upload"
        }else if(this.bcl_action === 'create_lot'){
            endpoint = '/api/v2/warehouse/inventory_file_uploads';
            params.search_text = this.search_tag;
            params.status = "Competitive Lot"
        }else if(this.bcl_action === 'pending_dispatch_file_upload'){
            endpoint = '/api/v2/warehouse/inventory_file_uploads';
            params.search_text = this.search_tag;
            params.status = "Liquidation Order File Upload"
        }else if(this.headerText === 'Location Master'){
            endpoint = '/admin/master_file_uploads?file_type=Location Master';
            params.filename = this.search_tag;
        }else if(this.headerText === 'Location Mapping'){
            endpoint = '/admin/master_file_uploads?file_type=Location Mapping';
            params.filename = this.search_tag;
        }else if(this.headerText === 'User Master'){
            endpoint = '/admin/master_file_uploads?file_type=User Master';
            params.filename = this.search_tag;
        }else if(this.headerText === 'User Mapping'){
            endpoint = '/admin/master_file_uploads?file_type=User Configuration';
            params.filename = this.search_tag;
        }else if(this.headerText === 'Category Master'){
            endpoint = '/admin/master_file_uploads?file_type=Master Category';
            params.filename = this.search_tag;
        }else if(this.headerText === 'SKU Master'){
            endpoint = '/admin/master_file_uploads?file_type=Master Sku';
            params.filename = this.search_tag;
        }else if(this.headerText === 'Attribute Master'){
            endpoint = '/admin/master_file_uploads?file_type=Master Attribute';
            params.filename = this.search_tag;
        }else if(this.headerText === 'Price Master'){
            endpoint = '/admin/master_file_uploads?file_type=Master Price';
            params.filename = this.search_tag;
        }else if(this.headerText === 'BOM Master'){
            endpoint = '/admin/master_file_uploads?file_type=Master Bom';
            params.filename = this.search_tag;
        }else if(this.headerText === 'Recovery' || this.headerText === 'Cost'){
            endpoint = 'api/v1/warehouse/prd/file_uploads?file_type=ThirdPartyClaimData';
            params.filename = this.search_tag;
        }else if(this.headerText === 'Vendor Master'){
            endpoint = '/admin/master_file_uploads?file_type=Vendor Master';
            params.filename = this.search_tag;
        }else if(this.headerText === 'Vendor Mapping'){
            endpoint = '/admin/master_file_uploads?file_type=Vendor Mapping';
            params.filename = this.search_tag;
        }else if(this.headerText === 'Approval Matrix'){
            endpoint = '/admin/master_file_uploads?file_type=Approval Matrix';
            params.filename = this.search_tag;
        }else if(this.headerText === 'offline_upload_template' && this.headerTextSub === 'Return Creation'){
            endpoint = '/admin/master_file_uploads';
            params.file_type = 'Return Creation Upload';
        }else if(this.headerTextSub === 'Return Creation'){
            endpoint = '/api/v1/warehouse/return_initiation/return_creations/file_uploads';
            params.search_text = this.search_tag;
        }else if(this.headerTextSub === 'Request & Tickets'){
            endpoint = 'admin/master_file_uploads';
            params.search_text = this.search_tag;
            params.file_type = 'Return Creation Approval Doc';
        }else if(this.headerText === 'Pending Confirmation'){
            endpoint = '/admin/master_file_uploads';
            params.file_type = 'Replacement';
            params.filename = this.search_tag;
        }else if(this.headerText === 'Pending Restock Location'){
            endpoint = '/admin/master_file_uploads';
            params.file_type = 'Restock';
            params.filename = this.search_tag;
        }else if(this.headerText === 'Pending Price & Location'){
            endpoint = '/admin/master_file_uploads';
            params.file_type = 'Markdown';
            params.filename = this.search_tag;
        }else if(this.headerTextSub === 'Transfer'){
            endpoint = '/admin/master_file_uploads';
            params.file_type = 'Transfer';
            params.filename = this.search_tag;
        }else if(this.headerText === 'Pending Repair'){
            endpoint = '/admin/master_file_uploads';
            params.file_type = 'Repair Dispatch';
            params.filename = this.search_tag;
        }else if(this.headerText === 'Pending Dispatch'){
            endpoint = '/admin/master_file_uploads';
            params.file_type = 'Pending Dispatch';
            params.filename = this.search_tag;
        }else if(this.headerText === 'AI Pricing File Upload'){
            endpoint = '/admin/master_file_uploads?file_type=AI Pricing';
            params.filename = this.search_tag;
        }else if(this.headerText === 'BB CRM Surrogate'){
            endpoint = '/admin/master_file_uploads';
            params.file_type = 'CRM Surrogate';
            params.filename = this.search_tag;
        }else if(this.headerTextSub === 'Manage Buyers'){
            endpoint = '/admin/master_file_uploads?file_type=Remarketing Buyer Upload';
            params.filename = this.search_tag;
        }else if(this.headerTextSub === 'Generate & Track Tag IDs'){
            endpoint = '/admin/master_file_uploads';
            params.file_type = 'Tag ID Generation';
            params.filename = this.search_tag;
        }else if(this.headerText === 'Create New Approval Config'){
            endpoint = '/admin/master_file_uploads';
            params.file_type = 'Approval Matrix';
            params.file_type_name = this.headerTextSub;
        }else if(this.headerText === 'Define Channel'){
            endpoint = '/admin/master_file_uploads';
            params.master_file_type = 'ChannelUpload';
            params.filename = this.search_tag;
        }else if(this.headerText === 'Return Reason Master'){
            endpoint = '/admin/master_file_uploads';
            params.master_file_type = 'ReturnReasonUpload';
            params.filename = this.search_tag;
        }else if(this.headerTextSub === 'Return Types Master'){
            endpoint = '/admin/master_file_uploads';
            params.master_file_type = 'ReturnTypeUpload';
            if(this.filename)
            params.filename = this.search_tag;
        }else if(this.headerTextSub === 'Entity-Variable Masters'){
            endpoint = '/admin/master_file_uploads';
            params.master_file_type = 'EntityVariableUpload';
            params.filename = this.search_tag;
        }else if(this.headerText === 'Attribute Configuartion'){
            endpoint = '/admin/master_file_uploads';
            params.master_file_type = "AttributeConfigurationUpload";
            params.filename = this.search_tag;
        }else if(this.headerText === 'Liquidation Price'){
            endpoint = '/admin/master_file_uploads';
            params.master_file_type = "LiquidationPriceUpload";
            params.search_text = this.search_tag;
        }else if(this.headerTextSub === 'Notification Types'){
            endpoint = '/admin/master_file_uploads';
            params.master_file_type = "SystemMasterTypeUpload";
            params.filename = this.search_tag;
            params.type_category = "notification";
        }else if(this.headerTextSub === 'Approval Type'){
            endpoint = '/admin/master_file_uploads';
            params.master_file_type = "SystemMasterTypeUpload";
            params.filename = this.search_tag;
            params.type_category = "approval";
        }else if(this.headerTextSub === 'Rule Type'){
            endpoint = '/admin/master_file_uploads';
            params.master_file_type = "SystemMasterTypeUpload";
            params.filename = this.search_tag;
            params.type_category = "rule";
        }else if(this.headerTextSub === 'Grading Type'){
            endpoint = '/admin/master_file_uploads';
            params.master_file_type = "SystemMasterTypeUpload";
            params.filename = this.search_tag;
            params.type_category = "grading";
        }else if(this.headerTextSub === 'Notification Template'){
            endpoint = '/admin/master_file_uploads';
            params.master_file_type = "NotificationTemplateUpload";
            params.filename = this.search_tag;
        }else if(this.headerText === 'Depreciation Master'){
            endpoint = '/admin/master_file_uploads';
            params.master_file_type = "DepreciationUpload";
            params.filename = this.search_tag;
        }else if(this.headerTextSub === 'Front End Title Master'){
            endpoint = '/admin/master_file_uploads';
            params.master_file_type = "FrontEndTitleMasterUpload";
            params.filename = this.search_tag;
        }else if(this.headerText === 'Field Nomenclature Mapping'){
            endpoint = '/admin/master_file_uploads';
            params.master_file_type = "FrontEndTitleMasterUpload";
            params.filename = this.search_tag;            
        }else if(this.headerTextSub === 'Physical Inspection'){
            endpoint = '/api/v1/physical_inspections/file_uploads';
            params.search_text = this.search_tag;
        }
        else{
            endpoint = '/api/v2/warehouse/inventory_file_uploads';
            params.search_text = this.search_tag;
        }
        this.$httpSecured
            .get(endpoint, { params: params })
            .then(response => {
             if (response.data.master_file_uploads) {
                    setTimeout(() => {
                        this.isRotating = false
                    }, 1000);
                this.isRotating = false
                this.table_data = response.data.master_file_uploads;
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
                this.search_key = '';
                this.loading = false;
            }else if(this.headerTextSub === 'Physical Inspection'){
                this.table_data = response.data.cycle_count_file_uploads.map(item => ({
                ...item,
                created_at: this.formatDate(item.created_at)
                }));
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
                this.loading = false;
            }else {
                this.table_data = response.data.inventory_file_uploads;
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
                this.loading = false;
            }
               
            })
            .catch(error => {
                this.loading = false;
                this.number = 0;
                this.$toast.error(error.response.data.message);
            });
    },
        getRouterLink() {
            // this.$store.commit("setLotIds", {
            //     action:this.bcl_action,
            // })
            if (this.headerText === 'Brand Call Log') {
                return { name: 'BrandCallLog' };
            }else if (this.headerText === 'Generate & Track Tag IDs') {
                return { name: 'generate' };
            } else if (this.headerText === 'Insurance') {
                return { name: 'InsuranceOperationsNew' };
            } else if (this.headerText === 'D2C Return Approval') {
                return { name: 'd2c_return_approval' };
            } else if (this.headerText === 'Dealer/Partner Return Approval') {
                return { name: 'dealer_partner_return_approval' };
            } else if (this.headerText === 'Internal Return Request Approval') {
                return { name: 'internal_return_approval' };
            } else if (this.headerText === 'Warranty Claim Approval') {
                return { name: 'warranty_claim_approval' };
            }else if(this.headerText === 'Inward Tracking'){
                return { name: 'inwardTracking' };
            } else if(this.headerText === 'RTV'){
                return { name : 'RTVModule'};
            } else if(this.headerText == 'Liquidation'){
                return { name : 'liquidationNew'}
            }else if(this.headerText == 'Location Master'){
                this.$store.commit("setActiveTab", {
                active_tab:'first_tab'
                });
                return { name : 'locationMaster'}
            }else if(this.headerText == 'Location Mapping'){
                this.$store.commit("setActiveTab", {
                active_tab:'second_tab'
                });
                return { name : 'locationMaster'}
            }else if (this.headerText == 'User Master') {
                this.$store.commit("setActiveTab", {
                active_tab:'first_tab'
                });
                return { name: 'userMaster' }
            }else if (this.headerText == 'User Mapping') {
                this.$store.commit("setActiveTab", {
                active_tab:'second_tab'
                });
                return { name: 'userMaster' }
            }else if(this.headerText == 'Category Master'){
               this.$store.commit("setActiveTab", {
                active_tab:'first_tab'
                });
                return { name : 'ItemMaster'} 
            }else if(this.headerText == 'SKU Master'){
               this.$store.commit("setActiveTab", {
                active_tab:'second_tab'
                });
                return { name : 'ItemMaster'} 
            }else if(this.headerText == 'Attribute Master'){
               this.$store.commit("setActiveTab", {
                active_tab:'third_tab'
                });
                return { name : 'ItemMaster'} 
            }else if(this.headerText == 'Price Master'){
               this.$store.commit("setActiveTab", {
                active_tab:'fourth_tab'
                });
                return { name : 'ItemMaster'} 
            }else if(this.headerText == 'BOM Master'){
               this.$store.commit("setActiveTab", {
                active_tab:'fifth_tab'
                });
                return { name : 'ItemMaster'} 
            }else if(this.headerText == 'Recovery'){
               this.$store.commit("setActiveTab", {
                active_tab:'first_tab'
                });
                return { name : 'threePClaim'} 
            }else if(this.headerText == 'Cost'){
               this.$store.commit("setActiveTab", {
                active_tab:'second_tab'
                });
                return { name : 'threePClaim'} 
            }else if (this.headerText == 'Vendor Master') {
                this.$store.commit("setActiveTab", {
                active_tab:'first_tab'
                });
                return { name: 'vendorMater' }
            }else if(this.headerText == 'Vendor Mapping'){
                this.$store.commit("setActiveTab", {
                active_tab:'second_tab'
                });
                return { name: 'vendorMater' }
            }else if (this.headerText == 'Approval Matrix') {
                this.$store.commit("setActiveTab", {
                active_tab:'first_tab'
                });
                return { name: 'approvalMatrix' }
            }else if(this.headerTextSub == 'Return Creation'){
                this.$store.commit("setActiveTab", {
                active_tab:'first_tab'
                });
                return { name: 'ReturnCreationRia' }
            }else if(this.headerTextSub === 'Request & Tickets'){
                this.$store.commit("setActiveTab", {
                active_tab:'first_tab'
                });
                return { name: 'ReturnCreationRia' }
            }else if(this.headerText == 'Pending Confirmation'){
                this.$store.commit("setActiveTab", {
                active_tab:'first_tab'
                });
                return { name: 'Replacement' }
            }else if(this.headerText == 'Pending Restock Location'){
                this.$store.commit("setActiveTab", {
                active_tab:'first_tab'
                });
                return { name: 'RestockComp' }
            }else if(this.headerText == 'Pending Price & Location'){
                this.$store.commit("setActiveTab", {
                active_tab:'first_tab'
                });
                return { name: 'MarkDown' }
            }else if(this.headerText == 'Pending Repair'){
                this.$store.commit("setActiveTab", {
                active_tab:'Pending Repair'
                });
                return { name: 'RepairModule' }
            }else if(this.headerText == 'Pending Dispatch'){
                this.$store.commit("setActiveTab", {
                active_tab:'Pending Dispatch'
                });
                return { name: 'NewDispatch' }
            }else if(this.headerTextSub === 'Transfer'){
                return { name: 'Transfer' }
            }else if(this.headerTextSub === 'BB CRM Surrogate'){
                return { name: 'bbCRMSurtogateFile' }
            }else if (this.headerTextSub === 'Manage Buyers') {
                this.$store.commit("setActiveTab", {
                active_tab:''
                });
                return { name: 'ManageUser' }
            }else if (this.headerText === 'Create New Approval Config') {
                return { name: 'CreateNewApprovalConfig' }
            }else if (this.headerText === 'Rule Engine Profile Master') {
                return { name: 'RuleEngineProfileMaster' }
            }else if(this.headerText == 'Attribute Configuartion'){
                return { name: 'DataValidationValues' }
            }else if(this.headerTextSub === 'Physical Inspection'){
                this.$store.commit("setActiveTab", {
                active_tab:''
                });
                return { name: 'PhysicalInspection' }
            }else if(this.headerText == 'System Masters'){
                this.$store.commit("setActiveTab", {
                active_tab:''
                });
                return { name: 'SystemMasters' }
            }else if(this.headerText == 'Define Channel' || this.headerText == 'Return Reason Master' || this.headerText == 'Liquidation Price' || this.headerText === 'Depreciation Master' || this.headerText === 'Field Nomenclature Mapping'){
                return { name: 'DataValidationValues' }
            }
        },
        getRouterLinkText() {
            if (this.headerText === 'Brand Call Log') {
                return this.bcl_action;
            } else if (this.headerText === 'Insurance') {
                return this.bcl_action;
            } else if (this.headerText === 'D2C Return Approval') {
                return this.headerText;
            } else if (this.headerText === 'Dealer/Partner Return Approval') {
                return this.headerText;
            } else if (this.headerText === 'Internal Return Request Approval') {
                return this.headerText;
            } else if (this.headerText === 'Warranty Claim Approval') {
                return this.headerText;
            }else if (this.headerText === 'Inward Tracking') {
                return this.headerText;
            } else if(this.headerText === 'RTV' || this.headerText == 'Liquidation'){
                return this.headerText;
            }else if(this.headerText == 'Location Master' || this.headerText == 'Category Master' || this.headerText == 'SKU Master' || this.headerText == 'Attribute Master' || this.headerText == 'Price Master' || this.headerText == 'BOM Master'){
                return this.headerText;
            }else if(this.headerText == 'Location Mapping'){
                return this.headerText;
            }else if (this.headerTextSub === 'User Master') {
                return this.headerText
            }else if (this.headerText === 'Recovery') {
                return this.headerText
            }else if (this.headerText === 'Cost') {
                return this.headerText
            }else if (this.headerTextSub === 'Vendor Master') {
                return this.headerText
            }else if (this.headerTextSub === 'Approval Matrix') {
                return this.headerText
            }else if(this.headerTextSub === 'Return Creation'){
                return this.headerTextSub
            }else if(this.headerTextSub === 'Request & Tickets'){
                return this.headerTextSub
            }else if(this.headerText == 'Pending Confirmation'){
                return this.headerText
            }else if(this.headerText == 'Pending Restock Location'){
                return this.headerText
            }else if(this.headerText == 'Pending Price & Location'){
                return this.headerText
            }else if(this.headerText == 'Pending Repair'){
                return this.headerText
            }else if(this.headerText == 'Pending Dispatch'){
                return this.headerText
            }else if(this.headerTextSub === 'Transfer'){
                return this.headerTextSub
            }else if(this.headerTextSub === 'BB CRM Surrogate'){
                return this.headerTextSub
            }else if (this.headerTextSub === 'Manage Buyers') {
                return this.headerTextSub
            }else if (this.headerText === 'Generate & Track Tag IDs') {
                return this.headerText;
            }else if(this.headerText === 'Create New Approval Config'){
                return this.headerTextSub
            }else if (this.headerText === 'Rule Engine Profile Master') {
                return this.headerText
            }else if(this.headerText == 'Attribute Configuartion'){
                return this.headerText
            }else if(this.headerText == 'System Masters'){
                return this.headerTextSub
            }else if(this.headerTextSub === 'Physical Inspection'){
                return this.headerTextSub
            }else if(this.headerText == 'Define Channel' || this.headerText == 'Return Reason Master' || this.headerText == 'Liquidation Price' || this.headerText === 'Depreciation Master' || this.headerText === 'Field Nomenclature Mapping'){
                return this.headerText
            }
        },
        componentsName(){
            if (this.headerText === 'Brand Call Log' || this.headerText === 'Insurance' || 
                 this.headerText === 'D2C Return Approval'|| this.headerText === 'Dealer/Partner Return Approval' || 
                 this.headerText === 'Internal Return Request Approval' || this.headerText === 'Warranty Claim Approval' || 
                 this.headerText == 'RTV' || this.headerText === 'Inward Tracking' || this.headerText == 'Liquidation' ||
                 this.headerTextSub == 'Location Master' || this.headerTextSub == 'User Master' || this.headerText == 'Category Master' || 
                 this.headerText == 'SKU Master' || this.headerText == 'Attribute Master' || this.headerText == 'Price Master' || 
                 this.headerText == 'BOM Master' || this.headerText == 'Recovery' || this.headerText == 'Cost' || 
                 this.headerTextSub == 'Vendor Master' || this.headerTextSub == 'Approval Matrix' || this.headerTextSub === 'Return Creation' || this.headerTextSub === 'Request & Tickets' || 
                 this.headerText == 'Pending Confirmation' || this.headerText == 'Pending Restock Location' || 
                 this.headerText == 'Pending Price & Location' || this.headerText == 'Pending Repair' || this.headerText == 'Pending Dispatch' || this.headerTextSub === 'Transfer' || 
                 this.headerTextSub === 'BB CRM Surrogate' || this.headerTextSub === 'Generate & Track Tag IDs' || 
                 this.headerTextSub === 'Manage Buyers' || this.headerText === 'Rule Engine Profile Master' || this.headerText === 'Attribute Configuartion' || 
                 this.headerText == 'System Masters' || this.headerText == 'Field Nomenclature Mapping' || this.headerText == 'Define Channel' || this.headerText == 'Return Reason Master' || this.headerText == 'Liquidation Price' || this.headerText === 'Depreciation Master' || this.headerTextSub === 'Physical Inspection') {
                return 'Upload Document';
         }
        },
        handlePageChange(value) {
            this.page = value;
            this.loadData();
        },
        handlePageSizeChange(size) {
            this.pageSize = size;
            this.page = 1
            this.loadData();
        },
        getFileName(file_url) {
          if (file_url === null) {
            return "File URL is null";
        }
        var arr = file_url.split('/');
        return arr[arr.length - 1];
      },
      uploadDocum(){
            this.fileUploadPopup = true;
            this.fileErrorMessage = '';
            this.fileError = false;
            this.upload_file = null;
            this.confirmButton='CONFIRM';
            this.headerText === 'Liquidation' ? this.cancel_button_hide = true : this.cancel_button_hide = false;
        },
        cancelUploadFile(){
            this.fileUploadPopup = false;
            this.number = 0;
            this.upload_file = null;
            this.uploadPercentage = 0;
            this.uploading = false;
        },
        confirmUploadFile() {
            this.uploadFile('start')
            this.number++;
            const formData = new FormData();
            if(this.headerTextSub === 'Location Master'){
                formData.append('master_file', this.upload_file);
            }
            // else{
            //     formData.append('file', this.upload_file);
            // }
            
            if (this.bcl_condition === 'brand_call_log') {
                if(this.bcl_action === 'Pending Information'){
                    this.status_name = 'pending_information'
                }else if(this.bcl_action === 'Pending BCL Tickets'){
                    this.status_name = 'pending_bcl_ticket'
                }else if(this.bcl_action === 'Pending Inspection'){
                    this.status_name = 'pending_inspection'
                }else{
                    this.status_name = 'pending_decision'
                }
                formData.append('status',this.status_name);
                var apiUrl = '/api/v1/warehouse/brand_call_logs/upload_csv_file';
                // formData.append('file', this.upload_file);
                const file = new Blob([this.upload_file], { type: 'text/csv' });
                formData.append('file',file,this.upload_file.name);
            } else if(this.bcl_condition === 'insurance_operations') {
                if(this.bcl_action === 'Pending Information'){
                    this.status_name = 'pending_information'
                }else if(this.bcl_action === 'Pending Claim Ticket'){
                    this.status_name = 'pending_claim_ticket'
                }else if(this.bcl_action === 'Pending Inspection'){
                    this.status_name = 'pending_inspection'
                }else{
                     this.status_name = 'pending_decision'
                    }
                formData.append('status',this.status_name);
                var apiUrl = '/api/v1/warehouse/new_insurances/upload_csv_file';
                // formData.append('file', this.upload_file);
                const file = new Blob([this.upload_file], { type: 'text/csv' });
                formData.append('file',file,this.upload_file.name);
            }else if(this.headerText === 'Dealer/Partner Return Approval'){
                formData.append('file', this.upload_file);
                formData.append('file_type','Dealer Partner Return Upload');
                var apiUrl = '/api/v1/warehouse/prd/upload_file';
            }else if(this.headerText === 'Inward Tracking'){
                formData.append('file', this.upload_file);
                var apiUrl = '/api/v1/warehouse/inward_tracking/upload_csv_file';
            }else if(this.headerText === 'RTV'){
                formData.append('file', this.upload_file);
                formData.append('inward_type', 'Rtv File Upload');
                var apiUrl = '/api/v2/warehouse/inventory_file_uploads'
            }else if(this.bcl_action === 'create_lot'){
                formData.append('file', this.upload_file);
                formData.append('inward_type', 'Competitive Lot');
                var apiUrl = '/api/v2/warehouse/inventory_file_uploads'
            }else if(this.bcl_action === 'pending_dispatch_file_upload'){
                formData.append('file', this.upload_file);
                formData.append('inward_type', 'Liquidation Order File Upload');
                var apiUrl = '/api/v2/warehouse/inventory_file_uploads'
            }else if(this.headerText === 'Location Master'){
                formData.append('file', this.upload_file);
                formData.append('master_file_type', 'Location Master');
                var apiUrl = '/admin/master_file_uploads'
            }else if(this.headerText === 'Location Mapping'){
                formData.append('file', this.upload_file);
                formData.append('master_file_type', 'Location Mapping');
                var apiUrl = '/admin/master_file_uploads'
            }else if(this.headerText === 'User Master'){
                formData.append('file', this.upload_file);
                var apiUrl = '/api/v2/users/bulk_upload'
            }else if(this.headerText === 'User Mapping'){
                formData.append('file', this.upload_file);
                var apiUrl = '/api/v2/users/bulk_upload?file_type=User Configuration'
            }else if(this.headerText === 'Category Master'){
                formData.append('master_file', this.upload_file);
                formData.append('tab', 'Master Category')
                formData.append('master_file_type', 'Master Category');
                var apiUrl = '/api/v2/warehouse/item_masters/bulk_add'
            }else if(this.headerText === 'SKU Master'){
                formData.append('master_file', this.upload_file);
                formData.append('tab', 'Master Sku')
                formData.append('master_file_type', 'Master Sku');
                var apiUrl = '/api/v2/warehouse/item_masters/bulk_add'
            }else if(this.headerText === 'Attribute Master'){
                formData.append('master_file', this.upload_file);
                formData.append('tab', 'Master Attribute')
                formData.append('master_file_type', 'Master Attribute');
                var apiUrl = '/api/v2/warehouse/item_masters/bulk_add'
            }else if(this.headerText === 'Price Master'){
                formData.append('master_file', this.upload_file);
                formData.append('tab', 'Master Price')
                formData.append('master_file_type', 'Master Price');
                var apiUrl = '/api/v2/warehouse/item_masters/bulk_add'
            }else if(this.headerText === 'BOM Master'){
                formData.append('master_file', this.upload_file);
                formData.append('tab', 'Master Bom')
                formData.append('master_file_type', 'Master Bom');
                var apiUrl = '/api/v2/warehouse/item_masters/bulk_add'
            }else if(this.headerText === 'Recovery' || this.headerText === 'Cost'){
                formData.append('file', this.upload_file);
                var apiUrl = '/api/v1/warehouse/third_party_claims/upload'
            }else if(this.headerText === 'Vendor Master'){
                formData.append('file', this.upload_file);
                formData.append('file_type', 'Vendor Master');
                var apiUrl = '/api/v2/vendor_masters/bulk_upload'
            }else if(this.headerText === 'Vendor Mapping'){
                formData.append('file', this.upload_file);
                formData.append('file_type', 'Vendor Mapping');
                var apiUrl = '/api/v2/vendor_masters/bulk_upload'
            }else if(this.headerText === 'Approval Matrix'){
                formData.append('master_file', this.upload_file);
                formData.append('master_file_type', 'Approval Matrix');
                var apiUrl = '/admin/master_file_uploads'
            }else if(this.headerText === 'offline_upload_template' && this.headerTextSub === 'Return Creation'){
                formData.append('master_file', this.upload_file);
                formData.append('master_file_type', "Return Creation Upload");
                var apiUrl = '/admin/master_file_uploads'
            }else if(this.headerTextSub === 'Return Creation'){
                formData.append('file', this.upload_file);
                var apiUrl = '/api/v1/warehouse/return_initiation/return_creations/upload_file'
            }else if(this.headerText == 'Pending Confirmation'){
                formData.append('master_file', this.upload_file);
                formData.append('master_file_type', 'Replacement');
                var apiUrl = '/api/v1/warehouse/replacements/upload_data'
            }else if(this.headerText == 'Pending Restock Location'){
                formData.append('master_file', this.upload_file);
                formData.append('master_file_type', 'Restock');
                var apiUrl = '/api/v1/warehouse/restocks/bulk_upload_restock'
            }else if(this.headerText == 'Pending Price & Location'){
                formData.append('master_file', this.upload_file);
                formData.append('master_file_type', 'Markdown');
                var apiUrl = '/api/v2/warehouse/markdown/pending_price_and_location/bulk_upload_markdowns'
            }else if(this.headerTextSub === 'Transfer'){
                formData.append('master_file', this.upload_file);
                formData.append('master_file_type', 'Transfer');
                var apiUrl = '/api/v1/transfer_inventories/bulk_upload_transfers'
            }else if(this.headerText == 'Pending Repair'){
                formData.append('master_file', this.upload_file);
                formData.append('master_file_type', 'Repair Dispatch');
                var apiUrl = '/api/v1/warehouse/new_repairs/upload_to_be_dispatched_items'
            }else if(this.headerText == 'Pending Dispatch'){
                formData.append('master_file', this.upload_file);
                formData.append('master_file_type', 'Pending Dispatch');
                var apiUrl = '/api/v1/warehouse/dispatch/upload_pending_dispatch_items'
            }else if(this.headerText === 'AI Pricing File Upload'){
                formData.append('file', this.upload_file);
                formData.append('file_type', 'AI Pricing');
                var apiUrl = '/api/v2/ai_pricings/bulk_upload';
            }else if(this.headerText === 'BB CRM Surrogate'){
                formData.append('file', this.upload_file);
                var apiUrl = '/api/v2/crm_surrogates/bulk_upload'
            }else if(this.headerTextSub === 'Manage Buyers'){
                formData.append('file', this.upload_file);
                var apiUrl = '/api/v1/warehouse/remarketing_buyers/bulk_upload'
            }else if(this.headerTextSub === 'Generate & Track Tag IDs'){
                formData.append('file', this.upload_file);
                formData.append('file_type', 'Tag ID Generation');
                var apiUrl = '/api/v2/tag_number_generation/file_upload'
            }else if(this.headerText === 'Define Channel'){
                formData.append('file', this.upload_file);
                formData.append('master_file_type', 'ChannelUpload');
                var apiUrl = '/api/v2/bulk_upload/bulk_upload'    
            }else if(this.headerText === 'Return Reason Master'){
                formData.append('file', this.upload_file);
                formData.append('master_file_type', 'ReturnReasonUpload');
                var apiUrl = '/api/v2/bulk_upload/bulk_upload'
            }else if(this.headerTextSub === 'Return Types Master'){
                formData.append('file', this.upload_file);
                formData.append('master_file_type', 'ReturnTypeUpload');
                var apiUrl = '/api/v2/bulk_upload/bulk_upload'
            }else if(this.headerTextSub === 'Entity-Variable Masters'){
                formData.append('file', this.upload_file);
                formData.append('master_file_type', 'EntityVariableUpload');
                var apiUrl = '/api/v2/bulk_upload/bulk_upload'
            }else if(this.headerText === 'Attribute Configuartion'){
                formData.append('file', this.upload_file);
                formData.append('master_file_type', 'AttributeConfigurationUpload');
                formData.append('entity_name', this.$store.state.entity_name);
                var apiUrl = '/api/v2/bulk_upload/bulk_upload'
            }else if(this.headerText === 'Liquidation Price'){
                formData.append('file', this.upload_file);
                formData.append('master_file_type', 'LiquidationPriceUpload');
                var apiUrl = '/api/v2/bulk_upload/bulk_upload'
            }else if(this.headerTextSub === 'Notification Types'){
                formData.append('file', this.upload_file);
                formData.append('type_category', "notification");
                formData.append('master_file_type', 'SystemMasterTypeUpload');
                var apiUrl = '/api/v2/bulk_upload/bulk_upload';
            }else if(this.headerTextSub === 'Approval Type'){
                formData.append('file', this.upload_file);
                formData.append('type_category', "approval");
                formData.append('master_file_type', 'SystemMasterTypeUpload');
                var apiUrl = '/api/v2/bulk_upload/bulk_upload';
            }else if(this.headerTextSub === 'Rule Type'){
                formData.append('file', this.upload_file);
                formData.append('type_category', "rule");
                formData.append('master_file_type', 'SystemMasterTypeUpload');
                var apiUrl = '/api/v2/bulk_upload/bulk_upload';
            }else if(this.headerTextSub === 'Grading Type'){
                formData.append('file', this.upload_file);
                formData.append('type_category', "grading");
                formData.append('master_file_type', 'SystemMasterTypeUpload');
                var apiUrl = '/api/v2/bulk_upload/bulk_upload';
            }else if(this.headerTextSub === 'Notification Template'){
                formData.append('file', this.upload_file);
                formData.append('master_file_type', 'NotificationTemplateUpload');
                var apiUrl = '/api/v2/bulk_upload/bulk_upload';
            }else if(this.headerText === 'Depreciation Master'){
                formData.append('file', this.upload_file);
                formData.append('master_file_type', 'DepreciationUpload');
                var apiUrl = '/api/v2/bulk_upload/bulk_upload';
            }else if(this.headerTextSub === 'Front End Title Master'){
                formData.append('file', this.upload_file);
                formData.append('master_file_type', 'FrontEndTitleMasterUpload');
                var apiUrl = '/api/v2/bulk_upload/bulk_upload';
            }else if(this.headerText === 'Field Nomenclature Mapping'){
                formData.append('file', this.upload_file);
                formData.append('master_file_type', 'FrontEndTitleMasterUpload');
                var apiUrl = '/api/v2/bulk_upload/bulk_upload';
            }else if(this.headerTextSub === 'Request & Tickets'){
                formData.append('file', this.upload_file);
                var apiUrl = '/api/v1/warehouse/return_initiation/return_creations/upload_approval_doc_file';
            }
            else{
                formData.append('file', this.upload_file);
                formData.append('inward_type', 'Competitive Lot');
                var apiUrl = '/api/v2/warehouse/inventory_file_uploads';
            }

            this.$httpSecured
                .post(apiUrl, formData)
                .then(response => {
                    // this.fileUploadPopup = false;
                    // this.messagePopup = true;
                    this.uploadFile('success')
                    this.action_name = 'success_msg';
                    this.message = "Successfully uploaded.";
                    this.messagePopWidth = "424px";
                    // this.number = 0;
                    // this.upload_file = '';
                })
                .catch(error => {
                    this.number = 0;
                    this.showAlert("error", error.response.data.message);
                });
        },
        changeFile(){
            if (this.upload_file) {
                const fileType = this.upload_file.type;
                const fileName = this.upload_file.name;
                const extension = fileName.split('.').pop().toLowerCase();
                if ((fileType !== 'text/csv' && fileType !== 'application/vnd.ms-excel') || extension !== 'csv') {
                    this.fileError = true;
                    this.fileErrorMessage = 'Only CSV files are allowed.';
                } else {
                    this.fileError = false;
                    this.fileErrorMessage = '';
                }
            } else {
                this.confirmButton = 'CONFIRM';
            }
        },
        uploadFile(status) {
            var percentage;
            this.uploading = true;
            let reader = new FileReader();
             if(status === 'start'){
                 reader.onprogress = (event) => {
                if (event.lengthComputable) {
                    percentage = Math.round((event.loaded / event.total) * 50);
                    this.uploadPercentage = percentage;
                }
            };
             }else if(status === 'success'){
                reader.onprogress = (event) => {
                if (event.lengthComputable) {
                 percentage = Math.round((event.loaded / event.total) * 100);
                this.uploadPercentage = percentage;
                this.uploading = false;
                this.completed = true;
                this.cancel_button_hide = true;               
                }
            };
             }
            reader.onloadend = (event) => {
                if(status === 'success'){
                setTimeout(() => {
                this.uploading = false;
                this.completed = false;
                this.uploadPercentage = 0;
                this.number = 0;
                this.confirmButton = 'FINISH';
                }, 2000);
                }                
            };
            reader.readAsDataURL(this.upload_file);
        },
         clickFinish(){
            this.fileUploadPopup = false;
            // this.loadData();   
            this.messagePopup = true;
            setTimeout(() => {
                this.upload_file = null;
            }, 2000);

        },
        showError(item){            
            // const temp = item.filename.split('.')
            this.master_url = item;         
            if(this.headerTextSub === 'User Master' || this.headerTextSub === 'Vendor Master' || this.headerTextSub === 'Item Master' || this.headerTextSub === 'Location Master' || this.headerTextSub === 'Approval Matrix' || this.headerTextSub === 'Replacement' || 
                 this.headerTextSub === 'Restock'  || this.headerTextSub === 'Markdown'|| this.headerTextSub === 'Generate & Track Tag IDs' || this.headerTextSub === 'Repair' || this.headerTextSub === 'Dispatch' || this.headerText === 'RTV' || this.headerTextSub === 'Transfer' || 
                 this.headerTextSub === 'AI Pricing File Upload' || this.headerTextSub === 'BB CRM Surrogate'|| this.headerTextSub === 'Manage Buyers' || this.headerTextSub === 'Physical Inspection' || this.headerTextSub === 'Return Creation' || this.headerTextSub === 'Request & Tickets'){      
                  this.message = item.remarks;
                    let errorFileLink = null;
                    if (item.errors_file && typeof item.errors_file === 'object' && item.errors_file.url) {
                         errorFileLink = item.errors_file.url;
                    }
                    else if (item.errors_file && typeof item.errors_file === 'string') {
                          errorFileLink = item.errors_file;
                    }else if(item.error_file && typeof item.error_file === 'string'){
                          errorFileLink = item.error_file
                    }
                if (errorFileLink) {
                    const link = document.createElement('a');
                    link.href = errorFileLink;
                    link.setAttribute('download', this.file_name_for_error);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.messagePopup = false;
                } else{
                    this.messagePopup = true;
                }
                    const temp = item.file_name
                    this.file_name_for_error = temp
                }else{
                    this.messagePopup = true;
                    this.message = item.remarks;
                    const temp = item.inventory_file ? this.getFileName(item.inventory_file['url']) : '';
                    this.file_name_for_error = item.file_name ? item.file_name : temp
                }
            
            this.messagePopWidth = "700px";
            this.action_name = 'download_error';
        },
        downloadError(){
            const url = window.URL.createObjectURL(new Blob([this.message.split(',').join('\n')]));
            const link = document.createElement('a');
            if(this.headerTextSub === 'Return Creation'){
                link.href = this.master_url.error_file ;
            }else if(this.headerText === 'Liquidation'){
               link.href = this.master_url.inventory_file.url;
            }else if(this.headerText === 'Brand Call Log'){
               link.href = this.master_url.inventory_file.url;
            }else{
               link.href = this.master_url.master_file.url;     
            } 
            link.setAttribute('download', `${this.file_name_for_error}_error.txt`);
            document.body.appendChild(link);
            link.click();
            this.action_name = 'success_msg';
            this.message = "Error Downloaded Successfully Completed";
            this.messagePopWidth = "424px"
        },
        downloadDocum(item){
            const link = document.createElement('a');
            if (this.headerText === 'Dealer/Partner Return Approval' || this.headerTextSub === 'Location Module' || this.headerTextSub === 'Item Master' || this.headerTextSub === '3P Claim'){
                link.href = item.master_file.url;
            }else if(this.headerText === 'User Master' || this.headerText === 'User Mapping' || 
                    this.headerText === 'Vendor Master' || this.headerText === 'Vendor Mapping' || 
                    this.headerText === 'Location Master' || this.headerText === 'Location Mapping' || 
                    this.headerText === 'Approval Matrix' || this.headerTextSub === 'Return Creation' || this.headerTextSub === 'Request & Tickets' ||
                    this.headerText === 'Pending Confirmation' || this.headerText == 'Pending Restock Location' || 
                    this.headerText == 'Pending Price & Location' || this.headerText == 'Pending Repair' || this.headerText == 'Pending Dispatch' || 
                    this.headerTextSub === 'Transfer' || this.headerTextSub === 'AI Pricing File Upload' || this.headerTextSub === 'BB CRM Surrogate' || this.headerTextSub === 'Manage Buyers' || this.headerText === 'Create New Approval Config' ||
                    this.headerText === 'Define Channel' || this.headerText === 'Return Reason Master' || this.headerTextSub === 'Return Types Master' || this.headerTextSub === 'Entity-Variable Masters' || 
                    this.headerTextSub === 'Attribute Configuartion' || this.headerText === 'Liquidation Price' || this.headerTextSub === 'Notification Types' || this.headerTextSub === 'Approval Type' || this.headerTextSub === 'Rule Type' || this.headerTextSub === 'Grading Type' || this.headerTextSub === 'Notification Template' || 
                    this.headerText === 'Depreciation Master' || this.headerTextSub === 'Front End Title Master' || this.headerText === 'Field Nomenclature Mapping'){
                link.href = item.master_file.url;
            }else if(this.headerTextSub === 'Physical Inspection'){
                link.href = item.file_url;
            }else{
                link.href = item.inventory_file.url;
            }            
            link.setAttribute('download', this.file_name_for_error);
            document.body.appendChild(link);
            link.click();
        },
        downloadSampleFile(){
            var api = '';
            if (this.headerText === 'User Master'){
                api = '/api/v2/users/download_sample_file'
            }else if(this.headerText === 'User Mapping'){
               api = '/api/v2/users/download_sample_file?file_type=User Configuration'
            }else if(this.headerText === 'AI Pricing File Upload'){
               api = '/api/v2/ai_pricings/download_sample_file'
            }else if(this.headerText === 'BB CRM Surrogate'){
               api = '/api/v2/crm_surrogates/download_sample_file'
            }else{
               api = "/api/v1/warehouse/return_initiation/return_approvals/download"
            }            
            this.$httpSecured
            .get(api)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const file_name = 'dealer_partner_sample';
                    link.setAttribute('download', `${file_name}.csv`);
                    document.body.appendChild(link);
                    link.click();
                    this.$toast.success("Dealer Partner Sample file downloaded!");
                })
                .catch(error => {
                    this.number = 0;
                    this.$toast.error(error.response.data.message);
                });
        },
        downloadSampleFileUserMaster(){
            var apiUrl = "";
            const params = { };
            if(this.headerText === 'Category Master'){
                params.is_sample = true;
                params.tab = 'Master Category';
                apiUrl = '/api/v2/warehouse/item_masters/download';
            }else if(this.headerText === 'SKU Master'){
                params.is_sample = true;
                params.tab = 'Master Sku';
                apiUrl = '/api/v2/warehouse/item_masters/download';
            }else if(this.headerText === 'Attribute Master'){
                params.is_sample = true;
                params.tab = 'Master Attribute';
                apiUrl = '/api/v2/warehouse/item_masters/download';
            }else if(this.headerText === 'Price Master'){
                params.is_sample = true;
                params.tab = 'Master Price';
                apiUrl = '/api/v2/warehouse/item_masters/download';
            }else if(this.headerText === 'BOM Master'){
                params.is_sample = true;
                params.tab = 'Master Bom';
                apiUrl = '/api/v2/warehouse/item_masters/download';
            }else if (this.headerText === 'User Master'){
                apiUrl = '/api/v2/users/download_sample_file'
            }else if (this.headerText === 'BB CRM Surrogate'){
                apiUrl = '/api/v2/crm_surrogates/download_sample_file'
            }else if(this.headerText === 'User Mapping'){
                apiUrl = '/api/v2/users/download_sample_file?file_type=User Configuration'
            }else if (this.headerText === 'Vendor Master'){
                apiUrl = '/api/v2/vendor_masters/download_sample_file'
            }else if(this.headerText === 'Vendor Mapping'){
                apiUrl = '/api/v2/vendor_masters/download_sample_file?file_type=Vendor Configuration'
            }else if (this.headerTextSub === 'Manage Buyers'){
                apiUrl = '/api/v1/warehouse/remarketing_buyers/download_sample_file'
            }else if(this.headerTextSub === 'Location Master' || this.headerTextSub === 'Approval Matrix'){
                this.downloadLocationSample();
                return;
            }else if (this.headerText === 'AI Pricing File Upload'){
                params.file_type = 'AI Pricing';
                apiUrl = '/api/v2/ai_pricings/download_sample_file'
            }else if(this.headerText === 'Brand Call Log'){
                apiUrl = '/sample_files/brand_call_log_sample.csv';
                this.downloadDirectFromBrowser(apiUrl);
                return;
            }else if(this.headerText === 'Insurance'){
                apiUrl = '/sample_files/insurance_file_sample.csv';
                this.downloadDirectFromBrowser(apiUrl);
                return;
            }else if(this.headerTextSub === 'Replacement'){
                apiUrl = '/sample_files/replacement_sample.csv';
                this.downloadDirectFromBrowser(apiUrl);
                return;  
            }else if(this.headerTextSub === 'Dispatch'){
                apiUrl = '/sample_files/dispatch_upload_sample.csv';
                this.downloadDirectFromBrowser(apiUrl);
                return;
            }else if(this.headerTextSub === 'Markdown'){
                apiUrl = '/sample_files/markdown_upload_sample.csv';
                this.downloadDirectFromBrowser(apiUrl);
                return;
            }else if(this.headerTextSub === 'Generate & Track Tag IDs'){
                apiUrl = '/sample_files/generate_tag_id_upload_sample.csv';
                this.downloadDirectFromBrowser(apiUrl);
                return;
            }else if(this.headerText === 'RTV'){
                apiUrl = '/sample_files/rtv_file_sample.csv';
                this.downloadDirectFromBrowser(apiUrl);
                return;   
            }else if(this.bcl_action === 'create_lot'){
                apiUrl = '/sample_files/lot_file_upload_sample.csv';
                this.downloadDirectFromBrowser(apiUrl);
                return;
            }else if(this.bcl_action == 'pending_dispatch_file_upload'){
                apiUrl = '/sample_files/lot_handover_dispatch_sample.csv';
                this.downloadDirectFromBrowser(apiUrl);
                return;
            }else if(this.headerText === 'Define Channel'){
                 apiUrl = '/api/v2/bulk_upload/download_sample_file?file_type=ChannelUpload'
            }else if(this.headerText === 'Return Reason Master'){
                 apiUrl = '/api/v2/bulk_upload/download_sample_file?file_type=ReturnReasonUpload'
            }else if(this.headerTextSub === 'Return Types Master'){
                 apiUrl = '/api/v2/bulk_upload/download_sample_file?file_type=ReturnTypeUpload'
            }else if(this.headerTextSub === 'Entity-Variable Masters'){
                 apiUrl = '/api/v2/bulk_upload/download_sample_file?file_type=EntityVariableUpload'
            }else if(this.headerText === 'Attribute Configuartion'){
                 apiUrl = `/api/v2/bulk_upload/download_sample_file?file_type=AttributeConfigurationUpload&entity_name=${this.$store.state.entity_name}`
            }else if(this.headerText === 'Liquidation Price'){
                apiUrl = '/api/v2/bulk_upload/download_sample_file?file_type=LiquidationPriceUpload'
            }else if(this.headerTextSub === 'Notification Types'){
                apiUrl = '/api/v2/bulk_upload/download_sample_file?file_type=SystemMasterTypeUpload&type_category=notification'
            }else if(this.headerTextSub === 'Approval Type'){
                apiUrl = '/api/v2/bulk_upload/download_sample_file?file_type=SystemMasterTypeUpload&type_category=approval'
            }else if(this.headerTextSub === 'Rule Type'){
                apiUrl = '/api/v2/bulk_upload/download_sample_file?file_type=SystemMasterTypeUpload&type_category=rule'
            }else if(this.headerTextSub === 'Grading Type'){
                apiUrl = '/api/v2/bulk_upload/download_sample_file?file_type=SystemMasterTypeUpload&type_category=grading'
            }else if(this.headerTextSub === 'Notification Template'){
                apiUrl = '/api/v2/bulk_upload/download_sample_file?file_type=NotificationTemplateUpload'
            }else if(this.headerText === 'Depreciation Master'){
                apiUrl = '/api/v2/bulk_upload/download_sample_file?file_type=DepreciationUpload'
            }else if(this.headerTextSub === 'Front End Title Master'){
                apiUrl = '/api/v2/bulk_upload/download_sample_file?file_type=FrontEndTitleMasterUpload'
            }else if(this.headerText === 'Field Nomenclature Mapping'){
                apiUrl = '/api/v2/bulk_upload/download_sample_file?file_type=FrontEndTitleMasterUpload'
            }
            this.$httpSecured
            .get(apiUrl, { params: params })
                .then(response => {
                    const link = document.createElement('a');
                    link.href = response.data.url; 
                    link.target = '_blank';
                    link.download = 'inventory.csv'; 
                    document.body.appendChild(link);
                    link.click();
                    this.$toast.success(`${this.headerText} Sample file downloaded!`);
                })
                .catch(error => {
                    this.number = 0;
                    this.$toast.error(error.response.data.message);
                });
        },
        downloadDirectFromBrowser(endpoint) {
                const baseURL = this.$httpSecured.defaults?.baseURL || '';
                const fullUrl = `${baseURL}${endpoint}`;
                this.$httpSecured
                    .get(endpoint)
                    .then((response) => {
                    const link = document.createElement('a');
                    link.href = fullUrl;
                    link.target = '_blank';
                    link.download = 'inventory.csv';
                    document.body.appendChild(link);
                    link.click();
                    this.$toast.success(`${this.headerText} Sample file downloaded!`);
                    })
                    .catch((error) => {
                    this.number = 0;
                    this.$toast.error(error.response?.data?.message || 'Something went wrong');
                    });
        },
        downloadLocationSample() {
            const formData = new FormData();
            if(this.headerText === 'Location Master'){
                formData.append('only_headers', 'true')
                var apiUrl = '/admin/distribution_centers/download_location_master'
            }else if(this.headerTextSub === 'Approval Matrix'){
                formData.append('only_headers', 'true');
                var apiUrl = '/api/v2/approval_matrix/download';
            }else{
                formData.append('only_headers', 'true');
                var apiUrl = '/admin/distribution_centers/download_location_mapping';
            }
            this.$httpSecured
                .post(apiUrl, formData)
                .then(response => {
                    const link = document.createElement('a');
                    link.href = response.data.url; 
                    link.target = '_blank';
                    link.download = 'inventory.csv'; 
                    document.body.appendChild(link);
                    link.click();
                    this.$toast.success(`${this.headerText} Sample file downloaded!`);
                })
                .catch(error => {
                    this.number = 0;
                    this.showAlert("error", error.response.data.message);
                });
        },
    formatDate(dateString) {
        if (!dateString) return '-';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    }
}
</script>
<style scoped>
.sample-file{
    position: absolute;
    right: 10px;
}
.sample-color{
    color: #0357D0;
}
.v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 320px) !important;
  }
.card-label-style{
    font-size: 16px;
    background-color: #f0f0f1;
    padding: 15px;
}
.rotate-once {
  animation: spin 1s linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>